import { getBaseDomain } from '../utils/domain';
import Cookies from 'universal-cookie';

interface SetterObject {
  vvs_utmcpg?: string;
  vvs_utmmed?: string;
  vvs_utmsrc?: string;
}

const cookies = new Cookies();
const cookieLifetime = 604800; // 604800 = 7 days
const domain = getBaseDomain();

export const set = (data: SetterObject) => {
  Object.keys(data).forEach((key) => {
    const value = data[key as keyof SetterObject];

    cookies.set(key, value || '', {
      path: '/',
      maxAge: cookieLifetime,
      domain,
    });
  });
};

export const get = (key: keyof SetterObject) => {
  return cookies.get(key as string);
};

export const getAll = (): SetterObject => ({
  vvs_utmcpg: cookies.get('vvs_utmcpg'),
  vvs_utmmed: cookies.get('vvs_utmmed'),
  vvs_utmsrc: cookies.get('vvs_utmsrc'),
});

export const cookieExists = () => {
  return !!(
    cookies.get('vvs_utmcpg') ||
    cookies.get('vvs_utmmed') ||
    cookies.get('vvs_utmsrc')
  );
};
